import type { ReactElement, ReactNode } from 'react';

import { cn } from '@/components/ui/cn';

import { STATUS_FILTERS, type StatusFilter } from '../use-catalog-view';

/** Filtro de estado (mismo control segmentado que Usuarios) y, si el catálogo lo
 *  usa, un filtro adicional a la izquierda (la norma, en normas y cláusulas). */
export function CatalogToolbar({
  status,
  onStatus,
  children,
}: {
  status: StatusFilter;
  onStatus: (s: StatusFilter) => void;
  children?: ReactNode;
}): ReactElement {
  return (
    <div className="filters">
      {children}
      <div className="seg" role="group" aria-label="Filtrar por estado">
        {STATUS_FILTERS.map((s) => (
          <button
            key={s.value}
            type="button"
            className={cn(status === s.value && 'on')}
            aria-pressed={status === s.value}
            onClick={() => onStatus(s.value)}
          >
            {s.label}
          </button>
        ))}
      </div>
    </div>
  );
}
